module.exports = __webpack_public_path__ + "static/media/79.0be17d8c.png";